var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { pick, Queue } from '@showroomjs/core';
import { a11yConfig } from './config';
export function checkA11y(element) {
    return __awaiter(this, void 0, void 0, function* () {
        return checkA11yQueue.queue(element);
    });
}
let _axe;
function getAxe() {
    return __awaiter(this, void 0, void 0, function* () {
        if (_axe) {
            return _axe;
        }
        const axe = yield import('axe-core');
        if (a11yConfig) {
            axe.configure(a11yConfig);
        }
        _axe = axe;
        return axe;
    });
}
const checkA11yQueue = new Queue(function checkA11yImpl(element) {
    return __awaiter(this, void 0, void 0, function* () {
        const axe = yield getAxe();
        const result = yield axe.run(element);
        return pick(result, ['passes', 'violations', 'incomplete']);
    });
});
//# sourceMappingURL=check-a11y.js.map